import { render, staticRenderFns } from "./ai_config.vue?vue&type=template&id=15169384&scoped=true"
import script from "./ai_config.vue?vue&type=script&lang=ts"
export * from "./ai_config.vue?vue&type=script&lang=ts"
import style0 from "./ai_config.vue?vue&type=style&index=0&id=15169384&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15169384",
  null
  
)

export default component.exports